/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitCardChallengeRequestDetails
 */
export interface SubmitCardChallengeRequestDetails {
    /**
     * 
     * @type {string}
     * @memberof SubmitCardChallengeRequestDetails
     */
    threeDSResult: string;
}

/**
 * Check if a given object implements the SubmitCardChallengeRequestDetails interface.
 */
export function instanceOfSubmitCardChallengeRequestDetails(value: object): value is SubmitCardChallengeRequestDetails {
    if (!('threeDSResult' in value) || value['threeDSResult'] === undefined) return false;
    return true;
}

export function SubmitCardChallengeRequestDetailsFromJSON(json: any): SubmitCardChallengeRequestDetails {
    return SubmitCardChallengeRequestDetailsFromJSONTyped(json, false);
}

export function SubmitCardChallengeRequestDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitCardChallengeRequestDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'threeDSResult': json['threeDSResult'],
    };
}

export function SubmitCardChallengeRequestDetailsToJSON(json: any): SubmitCardChallengeRequestDetails {
    return SubmitCardChallengeRequestDetailsToJSONTyped(json, false);
}

export function SubmitCardChallengeRequestDetailsToJSONTyped(value?: SubmitCardChallengeRequestDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threeDSResult': value['threeDSResult'],
    };
}

